import { Modal } from 'features/modalManager';
import { FullPageProps } from './FullPage';
import { t } from '@lingui/macro';
import styled from '@emotion/styled';

export const ModalForm = ({
  title,
  btnTitle,
  children,
  onClose,
  formId,
  disabledSave,
  onClick,
  icon,
  modalSx,
  description,
  tooltipTitleSave,
}: FullPageProps & { description?: React.ReactNode; tooltipTitleSave?: React.ReactNode }) => {
  return (
    <Modal
      description={description}
      modalSx={{
        window: { ...modalSx?.window },
        windowBody: {
          padding: `24px 24px`,
          paddingTop: `24px !important`,
          ...modalSx?.windowBody,
        },
      }}
      icon={icon}
      open
      id={formId || 'ModalForm'}
      hideDontShowAgain
      titleRootProps={{
        sx: {
          gap: '16px',
        },
      }}
      headerProps={{
        sx: {
          gap: '16px',
          '.modal-Controls': { top: 22 },
        },
      }}
      actions={[
        {
          id: 'cancel',
          label: t`Cancel`,
        },
        {
          id: 'apply',
          label: btnTitle,
          onClick,
          disabled: disabledSave,
          tooltipTitle: tooltipTitleSave,
        },
      ]}
      onClose={onClose}
      title={title}
    >
      <Body>{children}</Body>
    </Modal>
  );
};

const Body = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;
